/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

/**
 * Notes service
 * @namespace NotesService
 * @description Service for display of notes
 */
! function() {
    "use strict";

    angular.module('webReader').service('NotesService', constructor);
    /**
     * @name Styles
     * @function
     * @description Creates or returns reference to singleton object that allows to work with this service
     * @returns {Object} - singleton service object
     * @memberof NotesService
     */
    function constructor(DocumentService, DocumentModel) {
        var self = this;
        var notesCollection = [];
        var onNotesChange = [];
        var onNotesWrapperOffsetChange = []

        self.executeSubscriptions = function(callbacks, args) {
            var self = this;
            return _.every(callbacks, function(fn) {
                if (!_.isNull(fn)) {
                    return fn.apply(self, [args]) !== false;
                }
            })
        };

        self.subscribe = {
            onNotesChange: function(callback) {
                onNotesChange.push(callback);
            },
            onNotesWrapperOffsetChange: function(callback) {
                onNotesWrapperOffsetChange.push(callback);
            },
        };

        self.create = function(DOMElement) {
            //container = DOMElement;
        };

        self.createNote = function(noteObject, chapterId) {
            var newNoteObject = noteObject;
            newNoteObject.chapterId = chapterId;
            notesCollection.push(newNoteObject);
            var notesObjectCollection = DocumentService.getSelectionObjectsCollection(newNoteObject);
            _.map(notesObjectCollection, function(el, i) {
                if (!!el) {
                    if (!!el.targetElement) {
                        if (typeof noteObject.color === "undefined") {
                            noteObject.color = {
                                value: 'yellow'
                            }
                        }
                        // $('[name=content-mark ' + el.targetElement.uniqNavMark + ']').addClass('content-mark ' + noteObject.color.value);
                    } else {
                        $(el.element).addClass('content-mark ' + noteObject.color.value);
                    }
                }
            })
            self.executeSubscriptions.call(this, onNotesChange, {});

        };

        self.removeNote = function(uuid, noteObject) {
            var newNoteObject = noteObject;
            var notesObjectCollection;
            notesObjectCollection = DocumentService.getSelectionObjectsCollection(newNoteObject);
            _.each(notesObjectCollection, function(el, i) {
                if (!!el) {
                    if (!!el.targetElement) {
                        var sel = $('p [name="content-mark-' + el.targetElement.uniqNavMark + '"]');
                        sel.find('span').removeClass('content-mark ' + noteObject.color.value || 'yellow')
                        sel.removeClass('content-mark ' + noteObject.color.value);
                    } else {
                        $(el.element).removeClass()('content-mark ' + noteObject.color.value || 'yellow');
                    }
                }
            });


            for (var i = notesCollection.length - 1; i >= 0 && notesCollection[i].uuid !== uuid; i--) {};
            if (i >= 0) {
                notesCollection.splice(i, 1);
                self.executeSubscriptions.call(this, onNotesChange, {});
            }
        };

        self.getNotes = function() {
            return notesCollection;
        };

        self.updateScrollPosition = function(newPosition) {
            self.executeSubscriptions.call(this, onNotesWrapperOffsetChange, { newY: newPosition });
        };

        self.getNote = function(noteIndex) {
            return notesCollection[noteIndex];
        };
    }
    constructor.$inject = ["DocumentService", "DocumentModel"];
}();